import axios from 'axios';

let baseURL = import.meta.env.VITE_API_URL || '';

// Allow runtime override via localStorage for easy local simulator debugging
if (typeof window !== 'undefined') {
    const override = localStorage.getItem('CUSTOM_API_URL');
    if (override) {
        baseURL = override;
        console.log(`[API] Using custom API URL override: ${baseURL}`);
    }
}

const isNative = typeof window !== 'undefined' && !!(window as any).Capacitor?.isNativePlatform?.();

if (!isNative) {
    // For standard web browsers, always use relative /api paths to prevent CORS/CSP blocks
    // on sandbox environments (like -sbx.run.place) and production web.
    baseURL = '/api';
} else if (!baseURL) {
    // For native mobile apps (Capacitor), fall back to absolute URL
    if (import.meta.env.DEV) {
        baseURL = 'http://localhost:5001/api';
    } else {
        baseURL = 'https://www.petsmartmonitor.com/api';
    }
}
if (baseURL && baseURL.startsWith('http') && !baseURL.endsWith('/api') && !baseURL.endsWith('/api/')) {
    baseURL = baseURL.endsWith('/') ? `${baseURL}api` : `${baseURL}/api`;
}

export const api = axios.create({
    baseURL,
    withCredentials: true,
    timeout: 60000, // 60 seconds timeout to prevent premature timeout on large file uploads
});
